<template>
  <div class="service-link">
    <hr class="hr-divider margin-top-s" />
    <CategoryHeading :title="mobileTitles.shopByStore" />
    <ul class="grid-y margin-top-s hnf-service-links">
      <li>
        <MobileStore @on-select="select" />
      </li>
      <li v-for="(service, index) in items" :key="service.text" class="service-item grid-x align-middle">
        <ServiceLink :item="service" :position="index" />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { mobileTitles } from 'config';
import MobileStore from './MobileStore.common';
import ServiceLink from './ServiceLink.common';
import CategoryHeading from './CategoryHeading.common';
import { GET_SECONDARY_NAV } from '#shared/types/getters';

const navHeader = useNavHeader();

const emit = defineEmits(['onSelect']);
const items = computed(() => navHeader?.[GET_SECONDARY_NAV].filter(({ text }) => text?.toLowerCase() === 'stores'));

function select(paylaod) {
  emit('onSelect', paylaod);
}
</script>

<style lang="scss" scoped>
.service-link {
  ul.hnf-service-links {
    gap: map-get($grid-margin-gutters, 'medium');
  }
}
</style>
